var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12267 4.99997C9.12267 4.44768 9.57038 3.99997 10.1227 3.99997H12C16.9706 3.99997 21 8.02941 21 13C21 17.9705 16.9706 22 12 22C7.02944 22 3 17.9705 3 13C3 10.8746 3.73795 8.91891 4.97079 7.37898C5.31595 6.94785 5.94527 6.87815 6.37641 7.22331C6.80755 7.56848 6.87724 8.19779 6.53208 8.62893C5.57294 9.82697 5 11.3452 5 13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13C19 9.13398 15.866 5.99997 12 5.99997H10.1227C9.57038 5.99997 9.12267 5.55225 9.12267 4.99997Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 1.78264C13.0976 2.17316 13.0976 2.80633 12.7071 3.19685L10.8772 5.02679L12.7071 6.85673C13.0976 7.24725 13.0976 7.88042 12.7071 8.27094C12.3166 8.66147 11.6834 8.66147 11.2929 8.27094L8.75585 5.7339C8.36533 5.34338 8.36533 4.71021 8.75585 4.31969L11.2929 1.78264C11.6834 1.39212 12.3166 1.39211 12.7071 1.78264Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.29a5e3277c11af31992cf5cc46100f96.svg";
export { ForwardRef as ReactComponent };